











































































































































































































































import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import UserAvatar from '@/modules/shared/components/UserAvatar'
import ServerError from '@/utils/server_error'
import tournamentStore from '@/modules/tournament/tournament.store'
import userStore from '@/modules/auth/auth.store'
import {
  TournamentAPI,
  TournamentEntity,
  ConfirmTournamentTeamRosterRequest,
  TournamentVenueWithDetail,
  TournamentState
} from '@/api/tournament'
import {
  TournamentTeamEntity,
  TournamentPlayerEntity,
  TournamentTeamRole,
  TournamentTeamState
} from '@/api/tournamentTeam'

@Component({
  components: {
    UserAvatar
  }
})
export default class TournamentPlayers extends Vue {
  userModule = getModule(userStore, this.$store)
  tournamentModule = getModule(tournamentStore, this.$store)
  selectedTeamRoster: string[] = []
  confirmLoading: boolean = false
  undoConfirmLoading: boolean = false
  venues: TournamentVenueWithDetail[] = []
  selectedVenueId: string | null = null
  canChooseVenue: boolean = false

  removeMemberId: string = ''
  dialog: boolean = false

  @Prop({ default: false }) readonly selectingTeamRoster!: boolean
  @Prop({ default: false }) readonly waitingTeamRegistration!: boolean

  @Watch('tournamentTeam', { deep: true })
  async ontournamentTeamChanged(
    tournamentTeam: TournamentTeamEntity,
    oldtournamentTeam: TournamentTeamEntity
  ) {
    this.refreshSelectedTeamRoster()
  }

  /* Watchers */
  @Watch('tournament')
  async onTournamentChanged() {
    await this.refreshVenues()
  }

  @Watch('selectingTeamRoster')
  onSelectingTeamRoster() {
    this.selectedTeamRoster = []
    this.refreshSelectedTeamRoster()
  }

  @Watch('isTeamCaptain')
  onTeamCaptainChanged() {
    this.refreshSelectedTeamRoster()
  }

  /* Emitters */
  @Emit('confirmRoster')
  onConfirmRoster() {
    this.selectedTeamRoster = []
    return this
  }

  @Emit('unconfirmRoster')
  onUndoConfirmRoster() {
    this.refreshSelectedTeamRoster()

    return this
  }

  /* Vuex State */
  get tournament(): TournamentEntity | null {
    return this.tournamentModule.selectedTournament
  }

  get tournamentTeam(): TournamentTeamEntity | null {
    return this.tournamentModule.selectedTournamentTeam
  }

  get userId() {
    return this.userModule.userId
  }

  get players() {
    if (!this.tournamentTeam) return []

    return this.tournamentTeam.players.filter(
      player => player.role !== TournamentTeamRole.RequestToJoin
    )
  }

  /* Computed Properties */
  get remainingPlayers() {
    if (
      !this.tournament ||
      !this.tournamentTeam ||
      !this.tournamentTeam.players
    ) {
      return 0
    }

    let num = this.tournament.capacityMinPlayersPerTeam
    num -= this.tournamentTeam.players.filter(
      player => player.role !== TournamentTeamRole.RequestToJoin
    ).length
    return num < 0 ? 0 : num
  }

  get isTeamCaptain() {
    let tournamentTeam = this.tournamentTeam
    if (tournamentTeam && tournamentTeam.players) {
      return tournamentTeam.players.some(
        (player: TournamentPlayerEntity) =>
          player.memberId === this.userId &&
          player.role === TournamentTeamRole.Captain
      )
    }
    return false
  }

  get isSelectingTeamRoster() {
    return this.selectingTeamRoster && this.isTeamCaptain
  }

  get TournamentTeamRole() {
    return TournamentTeamRole
  }

  /* Vuex Actions */
  async confirmTournamentTeamRoster(
    tournamentId: string,
    tournamentTeamId: string,
    confirmTournamentTeamRosterRequest: ConfirmTournamentTeamRosterRequest
  ) {
    return this.tournamentModule.confirmTournamentTeamRoster({
      tournamentId,
      tournamentTeamId,
      confirmTournamentTeamRosterRequest
    })
  }

  async undoConfirmTournamentTeamRoster(tournamentTeamId: string) {
    return this.tournamentModule.undoConfirmTournamentTeamRoster(
      tournamentTeamId
    )
  }

  /* Methods */
  refreshSelectedTeamRoster() {
    this.selectedTeamRoster = []
    if (this.isTeamCaptain && this.isSelectingTeamRoster) {
      //  Only includes team captain
      if (!this.selectedTeamRoster.includes(this.userId))
        this.selectedTeamRoster.push(this.userId)
    } else if (!this.waitingTeamRegistration) {
      //  Show selected roster
      this.tournamentTeam!.players!.map((player: TournamentPlayerEntity) => {
        if (player.isStarter && player.memberId) {
          this.selectedTeamRoster.push(player.memberId)
        }
      })
    }
  }

  getTeamPlayerIsStarter(player: TournamentPlayerEntity) {
    return this.selectedTeamRoster.includes(player.memberId) || player.isStarter
  }

  async refreshVenues() {
    if (!this.tournament) {
      return
    }

    this.selectedVenueId = null
    this.canChooseVenue = false

    try {
      const res = await TournamentAPI.getTournamentVenues(
        this.tournament!.tournamentId
      )
      this.canChooseVenue = res.data.payload!.length > 0
      this.venues = res.data.payload!.filter(
        tv => !tv.quota || tv.current < tv.quota
      )
    } catch (err) {
      console.error(err)
    }
  }

  async onRemoveTeamMemberClick() {
    if (!this.isTeamCaptain || !this.removeMemberId || !this.tournamentTeam) {
      return
    }

    if (this.userId === this.removeMemberId) {
      return
    }

    try {
      let response = await this.tournamentModule.removeTournamentTeamMember({
        teamId: this.tournamentTeam.tournamentTeamId,
        memberId: this.removeMemberId
      })

      if (response) {
        this.$toast.success('Player removed from lineup')
        if (this.selectedTeamRoster.indexOf(this.removeMemberId) !== -1) {
          this.selectedTeamRoster.splice(
            this.selectedTeamRoster.indexOf(this.removeMemberId),
            1
          )
          // if selected more than capacity of tournament (unlikely to happen )
        }
      }
    } catch (err) {
      if (err instanceof ServerError) {
        this.$toast.error(err.getMessage())
      } else {
        this.$toast.error(this.$t('Misc.ErrorFetchData'))
        console.error(err)
      }
    } finally {
      this.dialog = false
    }
  }

  /* FIXME: To be refactor this section */
  onParticipantIndividualClick(userId: string) {
    // if not in selection mode or self selected.
    if (!this.isSelectingTeamRoster || userId === this.userId) {
      return false
    }

    // Undo action if target already selected
    if (this.selectedTeamRoster.indexOf(userId) !== -1) {
      this.selectedTeamRoster.splice(this.selectedTeamRoster.indexOf(userId), 1)
      // if selected more than capacity of tournament (unlikely to happen )
    } else if (this.teamRosterTotalCapacityExceeded) {
      this.$toast.error(
        this.$t('TournamentPlayers.YourTeamRosterReachesTheMaxNoOfPlayers'),
        {
          dismissable: true,
          icon: 'mdi-account-check-outline'
        }
      )
    } else if (this.teamRosterStarterCapacityExceeded) {
      this.$toast.error(
        this.$t('TournamentPlayers.TeamRosterStarterCapacityExceeded', {
          playersPerTeam: this.tournament!.capacityMinPlayersPerTeam
        }),
        {
          dismissable: true,
          icon: 'mdi-account-check-outline'
        }
      )
    } else {
      this.selectedTeamRoster.push(userId)
    }
  }

  async onConfirmTournamentTeamRosterClick() {
    if (!this.tournament || !this.tournamentTeam) {
      return
    }

    this.confirmLoading = true

    const confirmTournamentTeamRoster: ConfirmTournamentTeamRosterRequest = {
      memberIds: this.selectedTeamRoster.filter(
        (value, index, self) => self.indexOf(value) === index
      ),
      paymentMethod: undefined
    }

    try {
      const success = await this.confirmTournamentTeamRoster(
        this.tournament.tournamentId,
        this.tournamentTeam.tournamentTeamId,
        confirmTournamentTeamRoster
      )
      if (success) {
        this.$toast.success(
          this.$t('TournamentPlayers.TournamentTeamRosterConfirmed'),
          {
            dismissable: true,
            icon: 'mdi-account-check-outline'
          }
        )

        this.onConfirmRoster()
      }
    } catch (err) {
      if (err instanceof ServerError) {
        this.$toast.error(err.getMessage(), {
          dismissable: true,
          icon: 'mdi-account-check-outline'
        })
      } else {
        this.$toast.error(this.$t('TournamentPlayers.SystemErrorMessage'))
        console.error(err)
      }
    } finally {
      this.confirmLoading = false
    }
  }

  async onUndoConfirmRosterClick() {
    if (!this.tournament || !this.tournamentTeam) return

    this.undoConfirmLoading = true

    try {
      const success = await this.undoConfirmTournamentTeamRoster(
        this.tournamentTeam.tournamentTeamId
      )
      if (success) {
        this.$toast.success(
          this.$t('TournamentPlayers.TournamentTeamRosterUnconfirmed'),
          {
            dismissable: true,
            icon: 'mdi-account-cancel-outline'
          }
        )
      }

      this.onUndoConfirmRoster()
    } catch (err) {
      if (err instanceof ServerError) {
        this.$toast.error(err.getMessage(), {
          dismissable: true,
          icon: 'mdi-account-cancel-outline'
        })
      } else {
        this.$toast.error(this.$t('TournamentPlayers.SystemErrorMessage'))
        console.error(err)
      }
    } finally {
      this.undoConfirmLoading = false
    }
  }

  /* Computed Properties */
  get teamRosterTotalCapacityExceeded() {
    return (
      this.selectedTeamRoster.length >=
      this.tournament!.capacityMaxPlayersPerTeam
    )
  }

  get teamRosterStarterCapacityExceeded() {
    return (
      this.selectedTeamRoster.length >=
      this.tournament!.capacityMinPlayersPerTeam
    )
  }

  get isUndoConfirmRosterEnabled() {
    if (!this.tournamentTeam || !this.tournament) return false
    if (this.tournament.state !== TournamentState.OpenRegistration) return false
    return (
      this.tournamentTeam.state === TournamentTeamState.Registered &&
      this.isTeamCaptain
    )
  }

  /* Vue Hooks */
  mounted() {
    this.refreshSelectedTeamRoster()
    this.refreshVenues()
  }
}
